module.exports = __webpack_public_path__ + "9a7ece4fc89c6b89f21ef8e62ef8949e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/HamburgerIcon@2x.png
// module id = 52
// module chunks = 0